import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SubscriptionPage } from '../features/subscription/SubscriptionPage'
import { DURATION_OPTIONS, type DurationMonths } from '../features/subscription/subscriptionUtils'

// Deep-Link ?plan=<plan_id>[&duration=<1|3|6|12>] aus /plans — unbekannt/leer
// wird zu undefined, niemals ein Throw (Route muss auch bei kaputtem/fehlendem
// Param rendern). duration (Story 6.3): der auf /plans gewaehlte Laufzeit-
// Umschalter wird in den bestehenden Checkout-Flow uebernommen.
const subscriptionSearchSchema = z.object({
  plan: z
    .string()
    .optional()
    .transform((value) => (value ? value : undefined))
    .catch(undefined),
  duration: z.coerce
    .number()
    .optional()
    .transform((value) =>
      value !== undefined && (DURATION_OPTIONS as readonly number[]).includes(value)
        ? (value as DurationMonths)
        : undefined,
    )
    .catch(undefined),
  // Deep-Link ?change=<plan_id> öffnet direkt den Plan-Wechsel-Dialog (Paket C).
  change: z
    .string()
    .optional()
    .transform((value) => (value ? value : undefined))
    .catch(undefined),
})

export const Route = createFileRoute('/_auth/account/subscription')({
  validateSearch: subscriptionSearchSchema,
  component: SubscriptionRoute,
})

function SubscriptionRoute() {
  const search = Route.useSearch()

  return (
    <SubscriptionPage
      initialPlanId={search.plan}
      initialDuration={search.duration}
      initialChangePlanId={search.change}
    />
  )
}
